import { QueryParam, SignupFlow } from 'corgi-types';

import {
  ADDRESS_PATH,
  CHECKOUT_SIGNUP_URL,
  DIGITAL_ADDRESS_PATH,
  REGISTRATION_URL,
} from '../constants/checkout';
import { DEFAULT_FORM_ERROR } from '../constants/form';
import { isClient } from './isClient';

const SIGNUP_ERRORS = {
  NOT_FOUND: 'h24_signup_error_NOT_FOUND',
  NOT_ACCEPTABLE: 'h24_signup_error_NOT_ACCEPTABLE',
  BAD_CREDENTIALS: 'h24_signup_error_BAD_CREDENTIALS',
  CHALLENGE_VALIDATION_FAILED: 'h24_recaptcha_fail_error',
  RATE_LIMIT_EXCEEDED: 'h24_login_rate_limit_error',
};

export const shouldAddUserFlowQueryParam = (flow: SignupFlow) =>
  [
    SignupFlow.Cart,
    SignupFlow.Contact,
    SignupFlow.Wishlist,
    SignupFlow.ContentHomeClub,
    SignupFlow.CartHomeClub,
    SignupFlow.Checkout,
    SignupFlow.GiftCardCheckout,
    SignupFlow.Referral,
    SignupFlow.ReferralLanding,
  ].includes(flow);

export const getSignupErrorTranslationKey = (code: string, fallbackError = DEFAULT_FORM_ERROR) =>
  SIGNUP_ERRORS.hasOwnProperty(code) ? SIGNUP_ERRORS[code] : fallbackError;

export const getUserFlowQueryParam = (flow: SignupFlow) => {
  if (shouldAddUserFlowQueryParam(flow)) {
    let queryParams = `?userFlow=${flow}`;

    if (flow === SignupFlow.ReferralLanding && isClient()) {
      queryParams += `&${QueryParam.RedirectedFrom}=${window.location.href}`;
    }

    return queryParams;
  }

  return '';
};

export const getCtaCheckoutGuestHref = (userFlow: SignupFlow) => {
  if (userFlow === SignupFlow.GiftCardCheckout) {
    return `${DIGITAL_ADDRESS_PATH}&guest`;
  }

  return `${ADDRESS_PATH}&guest`;
};

export const getRegistrationHref = (userFlow: SignupFlow) => {
  return `${REGISTRATION_URL}${getUserFlowQueryParam(userFlow)}`;
};

export const getCheckoutLoginHref = (userFlow: SignupFlow) =>
  `${CHECKOUT_SIGNUP_URL}${getUserFlowQueryParam(userFlow)}`;
